<template>
  <div>{{ $t('404') }}</div>
</template>

<script>

export default {}

</script>
